"use client";

import { useSectionInView } from "./section";

/**
 * The Your-data section's emblem: a ring of twelve dots (the EU's) around a
 * cream core, turning slowly. The dots arrive one by one when the section
 * scrolls in; the rotation stops under reduced motion.
 */
export function EuRing() {
  const inView = useSectionInView();
  const dots = Array.from({ length: 12 }, (_, i) => {
    const a = -Math.PI / 2 + (i * Math.PI) / 6;
    return { cx: (100 + Math.cos(a) * 70).toFixed(2), cy: (100 + Math.sin(a) * 70).toFixed(2), delay: 300 + i * 90 };
  });
  return (
    <svg
      viewBox="0 0 200 200"
      aria-hidden="true"
      className="relative mb-8 aspect-square w-[130px] text-signal-soft opacity-90 md:absolute md:right-[clamp(20px,5vw,88px)] md:top-[clamp(90px,12vw,170px)] md:mb-0 md:w-[clamp(140px,16vw,230px)]"
    >
      <g className="animate-[sqSpin_90s_linear_infinite] motion-reduce:animate-none" style={{ transformOrigin: "100px 100px" }}>
        <circle cx="100" cy="100" r="70" fill="none" stroke="rgba(250,250,248,0.12)" strokeDasharray="2 6" />
        {dots.map((d) => (
          <circle
            key={d.cx + d.cy}
            cx={d.cx}
            cy={d.cy}
            r="5"
            fill="currentColor"
            className="motion-reduce:opacity-100! motion-reduce:scale-100! motion-reduce:transition-none"
            style={{
              opacity: inView ? 1 : 0,
              transform: inView ? "none" : "scale(0.6)",
              transformOrigin: "100px 100px",
              transition: `opacity 0.6s ease ${d.delay}ms, transform 0.8s cubic-bezier(0.2,0.7,0.1,1) ${d.delay}ms`,
            }}
          />
        ))}
        <circle cx="100" cy="100" r="8" fill="#FAFAF8" />
      </g>
    </svg>
  );
}
